export const IMPORT_NODES_URL = '/nodes/import-nodes';
export const GET_IMPOERT_PROPERTY_COUNT = '/projects-node-types/:id/property-counts';
